import { render, staticRenderFns } from "./IconEnvelop.vue?vue&type=template&id=7a7b398f&"
import script from "./IconEnvelop.vue?vue&type=script&lang=js&"
export * from "./IconEnvelop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports